// coupon-common/src/modules/impact/api.js
import axios from 'axios';

const BASE = '/affiliate-coupons';

export const getImpactCampaigns = () =>
  axios.get(`${BASE}/impact-campaigns/`);

export const getImpactDeals = (params = {}) =>
  axios.get(`${BASE}/impact-deals/`, { params });

export const getImpactCatalogs = (params = {}) =>
  axios.get(`${BASE}/impact-catalogs/`, { params });

export const getImpactCatalogItems = (params = {}) =>
  axios.get(`${BASE}/impact-catalog-items/`, { params });